import MacBookNeoAll from '../../../assets/apple/mac/MacNeo/MacBookNeoAll.png';
import Neo1 from '../../../assets/apple/mac/MacNeo/Neo1.png';
import Neo2 from '../../../assets/apple/mac/MacNeo/Neo2.png';
import Neo3 from '../../../assets/apple/mac/MacNeo/Neo3.png';
import Neo4 from '../../../assets/apple/mac/MacNeo/Neo4.png';
import MacBookAir1 from '../../../assets/apple/mac/MacBookAir/MacBookAir1.png';
import MacBookAir2 from '../../../assets/apple/mac/MacBookAir/MacBookAir2.png';
import MacBookAir3 from '../../../assets/apple/mac/MacBookAir/MacBookAir3.png';
import MacBookPro1 from '../../../assets/apple/mac/MacBookPro/MacBookPro1.png';
import MacBookPro2 from '../../../assets/apple/mac/MacBookPro/MacBookPro2.png';
import MacBookPro3 from '../../../assets/apple/mac/MacBookPro/MacBookPro3.png';

const macBookAirM5Images = [
  MacBookAir1,
  MacBookAir2,
  MacBookAir3,
];

const macBookProM5Images = [
  MacBookPro1,
  MacBookPro2,
  MacBookPro3,
];

const macBookAirM5CommonSpecifications = {
  'Design & Display': [
    'Available in 13.6-inch and 15.3-inch Liquid Retina displays with True Tone and P3 wide color.',
    'Bright 500-nit display with thin bezels and rounded corners.',
    'Lightweight aluminium design in Sky Blue, Silver, Starlight, and Midnight finishes.',
  ],
  Performance: [
    'Powered by the Apple M5 chip with up to 10-core CPU and 10-core GPU.',
    '16-core Neural Engine for AI and machine-learning tasks.',
    'Fanless design for silent and efficient performance.',
  ],
  'Battery & Power': [
    'Up to 18 hours of video streaming and around 15 hours of web browsing.',
    'Supports fast charging with MagSafe 3 and USB-C power adapters.',
  ],
  'Memory & Storage': [
    '16GB unified memory, configurable to 24GB or 32GB.',
    '512GB SSD standard, configurable up to 4TB.',
  ],
  'Camera & Audio': [
    '12MP webcam for video calls.',
    'Stereo speakers (13-inch) or six-speaker system (15-inch) with spatial audio.',
  ],
  'Connectivity & Ports': [
    'MagSafe 3, two Thunderbolt 4 (USB-C) ports, and 3.5 mm headphone jack.',
    'Supports up to two external displays and fast data transfer.',
  ],
  Software: [
    'Runs macOS with built-in apps and Apple Intelligence features for productivity and AI tools.',
  ],
};

const macBookProM5CommonSpecifications = {
  'Design & Display': [
    '14.2-inch and 16.2-inch Liquid Retina XDR displays with rounded corners.',
    'Optional nano-texture glass for reduced glare.',
    'Available in Space Black and Silver.',
  ],
  Performance: [
    'Powered by Apple M5, Apple M5 Pro, or Apple M5 Max chips.',
    'High-performance CPU, GPU, and Neural Engine designed for demanding professional workflows and AI tasks.',
  ],
  'Battery & Power': [
    'Up to ~24 hours of battery life depending on usage.',
    'Includes MagSafe 3 charging cable and power adapter.',
  ],
  'Memory & Storage': [
    'Unified memory configurable to higher capacities depending on chip.',
    'Starts with 1TB SSD storage, configurable up to 8TB.',
  ],
  'Camera & Audio': [
    '12MP Center Stage camera for video calls.',
    'Six-speaker sound system and studio-quality microphones.',
  ],
  Software: [
    'Runs macOS Tahoe with built-in apps and Apple Intelligence features.',
  ],
};

export const macProducts = [
  {
    id: 3,
    title: 'MacBook Neo (256GB)',
    productImage: MacBookNeoAll,
    images: [Neo1, Neo2, Neo3, Neo4],
    originalPrice: '79,900',
    discountedPrice: '79,900',
    colors: ['Silver', 'Indigo', 'Citrus', 'Blush'],
    offers: [
      { label: 'Offer', value: ' (Inclusive of credit card offers)' },
      { label: 'EMI', value: ' Credit Card EMI Available' },
    ],
    specifications: {
      Variant: [
        '256GB storage',
        'Magic Keyboard',
      ],
      'Design & Display': [
        'Durable design with multiple color options.',
        '13-inch Liquid Retina display with high resolution and brightness for sharp visuals.',
        'Rounded corners with a Liquid Glass design for improved clarity.',
      ],
      Performance: [
        'Powered by the Apple A18 Pro chip (6-core CPU, 5-core GPU).',
        'Handles everyday tasks, productivity apps, and AI-powered features smoothly.',
        'Optimized for Apple Intelligence for smart writing, summarization, and presentations.',
      ],
      'Battery Life': [
        'Up to ~16 hours of battery life on a single charge.',
        'Efficient power management for all-day use.',
      ],
      'Audio & Camera': [
        'Built-in microphones and speakers for calls and media.',
        'Camera optimized for video calls and FaceTime.',
      ],
      Security: [
        'Touch ID for secure login and purchases.',
        'Privacy-focused AI with on-device processing and Private Cloud Compute.',
      ],
      'Connectivity & Ecosystem': [
        'Seamless integration with iPhone with features like AirDrop, Handoff, Instant Hotspot, and Universal Clipboard.',
        'Multiple ports for connectivity.',
      ],
      Software: [
        'Runs macOS with free updates and built-in apps like Pages, Numbers, Keynote, GarageBand, and iMovie.',
      ],
    },
  },
  {
    id: 4,
    title: 'MacBook Neo (512GB)',
    productImage: MacBookNeoAll,
    images: [Neo1, Neo2, Neo3, Neo4],
    originalPrice: '89,900',
    discountedPrice: '89,900',
    colors: ['Silver', 'Indigo', 'Citrus', 'Blush'],
    offers: [
      { label: 'Offer', value: ' (Inclusive of credit card offers)' },
      { label: 'EMI', value: ' Credit Card EMI Available' },
    ],
    specifications: {
      Variant: [
        '512GB storage',
        'Magic Keyboard with Touch ID',
      ],
      'Design & Display': [
        'Durable design with multiple color options.',
        '13-inch Liquid Retina display with high resolution and brightness for sharp visuals.',
        'Rounded corners with a Liquid Glass design for improved clarity.',
      ],
      Performance: [
        'Powered by the Apple A18 Pro chip (6-core CPU, 5-core GPU).',
        'Handles everyday tasks, productivity apps, and AI-powered features smoothly.',
        'Optimized for Apple Intelligence for smart writing, summarization, and presentations.',
      ],
      'Battery Life': [
        'Up to ~16 hours of battery life on a single charge.',
        'Efficient power management for all-day use.',
      ],
      'Audio & Camera': [
        'Built-in microphones and speakers for calls and media.',
        'Camera optimized for video calls and FaceTime.',
      ],
      Security: [
        'Touch ID for secure login and purchases.',
        'Privacy-focused AI with on-device processing and Private Cloud Compute.',
      ],
      'Connectivity & Ecosystem': [
        'Seamless integration with iPhone with features like AirDrop, Handoff, Instant Hotspot, and Universal Clipboard.',
        'Multiple ports for connectivity.',
      ],
      Software: [
        'Runs macOS with free updates and built-in apps like Pages, Numbers, Keynote, GarageBand, and iMovie.',
      ],
    },
  },
  {
    id: 5,
    title: 'MacBook Air 13inch - M5 16/512 GB (8-Core GPU)',
    productImage: MacBookAir1,
    images: macBookAirM5Images,
    originalPrice: '1,49,900',
    discountedPrice: '1,49,900',
    colors: ['Sky Blue', 'Silver', 'Starlight', 'Midnight'],
    offers: [
      { label: 'Offer', value: ' (Inclusive of credit card offers)' },
      { label: 'EMI', value: ' Credit Card EMI Available' },
    ],
    specifications: {
      Variant: [
        '13-inch model',
        '512GB storage',
        '10-core CPU, 8-core GPU, 16-core Neural Engine',
      ],
      ...macBookAirM5CommonSpecifications,
    },
  },
  {
    id: 6,
    title: 'MacBook Air 13inch - M5 16/512 GB (10-Core GPU)',
    productImage: MacBookAir1,
    images: macBookAirM5Images,
    originalPrice: '1,61,900',
    discountedPrice: '1,61,900',
    colors: ['Sky Blue', 'Silver', 'Starlight', 'Midnight'],
    offers: [
      { label: 'Offer', value: ' (Inclusive of credit card offers)' },
      { label: 'EMI', value: ' Credit Card EMI Available' },
    ],
    specifications: {
      Variant: [
        '13-inch model',
        '512GB storage',
        '10-core CPU, 10-core GPU, 16-core Neural Engine',
      ],
      ...macBookAirM5CommonSpecifications,
    },
  },
  {
    id: 7,
    title: 'MacBook Air 15inch - M5 16/512 GB',
    productImage: MacBookAir1,
    images: macBookAirM5Images,
    originalPrice: '1,79,900',
    discountedPrice: '1,79,900',
    colors: ['Sky Blue', 'Silver', 'Starlight', 'Midnight'],
    offers: [
      { label: 'Offer', value: ' (Inclusive of credit card offers)' },
      { label: 'EMI', value: ' Credit Card EMI Available' },
    ],
    specifications: {
      Variant: [
        '15-inch model',
        '16GB unified memory',
        '512GB SSD storage',
      ],
      ...macBookAirM5CommonSpecifications,
    },
  },
  {
    id: 8,
    title: 'MacBook Pro 14inch - M5 16/1TB GB',
    productImage: MacBookPro1,
    images: macBookProM5Images,
    originalPrice: '2,39,900',
    discountedPrice: '2,39,900',
    colors: ['Silver', 'Space Black'],
    offers: [
      { label: 'Offer', value: ' (Inclusive of credit card offers)' },
      { label: 'EMI', value: ' Credit Card EMI Available' },
    ],
    specifications: {
      Variant: [
        '14-inch model',
        '16GB unified memory',
        '1TB SSD storage',
      ],
      ...macBookProM5CommonSpecifications,
    },
  },
  {
    id: 9,
    title: 'MacBook Pro 16inch - M5 Pro 24/1TB',
    productImage: MacBookPro1,
    images: macBookProM5Images,
    originalPrice: '3,59,900',
    discountedPrice: '3,59,900',
    colors: ['Silver', 'Space Black'],
    offers: [
      { label: 'Offer', value: ' (Inclusive of credit card offers)' },
      { label: 'EMI', value: ' Credit Card EMI Available' },
    ],
    specifications: {
      Variant: [
        '16-inch model',
        '24GB unified memory',
        '1TB SSD storage',
      ],
      ...macBookProM5CommonSpecifications,
    },
  },
];
